var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlagPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8DA5BF",
    d: "M3.5 3.5v35h55v-35h-55zm58-3v41H.5V.5h61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8DA5BF",
    d: "M28.447 25.185v-1.192c0-1.032.22-1.929.66-2.691.441-.763 1.247-1.574 2.418-2.433 1.128-.806 1.872-1.461 2.232-1.966.36-.505.54-1.069.54-1.692 0-.698-.258-1.23-.774-1.595-.516-.366-1.235-.548-2.16-.548-1.61 0-3.447.526-5.51 1.579l-1.756-3.529c2.395-1.343 4.936-2.014 7.621-2.014 2.213 0 3.972.532 5.277 1.595 1.306 1.064 1.958 2.482 1.958 4.254 0 1.182-.268 2.202-.806 3.062-.537.859-1.557 1.826-3.061 2.9-1.031.763-1.684 1.343-1.958 1.74-.274.398-.41.919-.41 1.563v.967h-4.27zm-.515 5.511c0-.903.241-1.585.725-2.047.483-.462 1.187-.692 2.11-.692.892 0 1.582.236 2.071.709.489.472.733 1.149.733 2.03 0 .848-.247 1.517-.74 2.006-.495.489-1.183.733-2.063.733-.903 0-1.601-.239-2.095-.717-.494-.478-.741-1.152-.741-2.022z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagPlaceholder);
export default __webpack_public_path__ + "static/media/icon-flag-placeholder.6cf3f992.svg";
export { ForwardRef as ReactComponent };